import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { hasRestrictedRole } from 'globalutils/fmUtils';
import { ROLES } from 'globalconfig/constants/keys';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ provider }) => {
  return {
    addBillOfLadingIfNeeded: {
      [SERVICE_PROVIDERS.RADIUS]: () => true,
      [SERVICE_PROVIDERS.WEBFLEET]: () => true,
      [SERVICE_PROVIDERS.NAUTO]: () => true,
      [SERVICE_PROVIDERS.TTS]: () => true,
      default: () => false,
    },
    applySpireonOverrides: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      default: () => false,
    },
    dutyStatus_reportKey: {
      [SERVICE_PROVIDERS.SPIREON]: () => 'dutyStatusReportFormSpireon',
      default: () => 'dutyStatusReportForm',
    },
    dutyStatus: {
      [SERVICE_PROVIDERS.EDVIR]: () => false,
      default: () => true,
    },
    driverPerformanceReport: {
      [SERVICE_PROVIDERS.EDVIR]: () => false,
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    editedDataReport: {
      [SERVICE_PROVIDERS.EDVIR]: () => false,
      default: () => true,
    },
    pendingMechanic: {
      [SERVICE_PROVIDERS.EDVIR]: () => hasRestrictedRole([ROLES.SERVICE_MANAGER]),
      default: () => false,
    },
    noOfRequestsPerDay: {
      [SERVICE_PROVIDERS.EDVIR]: () => hasRestrictedRole([ROLES.SERVICE_MANAGER]),
      default: () => false,
    },
    pastDueServiceRequests: {
      [SERVICE_PROVIDERS.EDVIR]: () => hasRestrictedRole([ROLES.SERVICE_MANAGER]),
      default: () => false,
    },
    pastDueServiceRequests_dateReportForm: {
      [SERVICE_PROVIDERS.EDVIR]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    pendingDriverDVIR: {
      [SERVICE_PROVIDERS.EDVIR]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    borderStates: {
      [SERVICE_PROVIDERS.RADIUS]: () => true,
      [SERVICE_PROVIDERS.NAUTO]: () => true,
      [SERVICE_PROVIDERS.TTS]: () => true,
      default: () => false,
    },
    bayIndustriesPayroll: {
      [SERVICE_PROVIDERS.EDVIR]: () => false,
      default: () => true,
    },
    allDutyTimeTracker: {
      [SERVICE_PROVIDERS.EDVIR]: () => false,
      default: () => true,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
